{
  "add": "Dodaj",
  "add-barn-first-description": "Najpierw dodaj kurnik w swoim profilu. Następnie możesz wprowadzić dostawę piskląt.",
  "add-cycle": "Dodaj cykl",
  "add-day-old-chick-first-description": "Najpierw uzupełnij dostawy piskląt. Następnie możesz zarejestrować sprzedaż.",
  "age": "Wiek piskląt",
  "amount": "Ilość",
  "app": {
    "cycles": "Cykle produkcyjne",
    "deliveries": "Dostawy",
    "reports": "Raporty",
    "settings": "Ustawienia",
    "products": "Produkty",
    "farmer-insights": "Widok hodowcy",
    "advices": "Porady",
    "feed-advice": "Doradztwo",
    "reference-value-sheet": "Arkusz wartości odniesienia",
    "standard-reference-value-sheet": "Standardowy arkusz wartości odniesienia",
    "reference-scheme": "Przegląd porady paszowej",
    "management": "Zarządzanie",
    "performance": "Wyniki",
    "within-cycle-performance": "Wydajność w ramach cyklu"
  },
  "farmer-insights": {
    "kpiGroups": {
      "TechnicalPerformance": "Parametry techniczne",
      "FinancialPerformance": "Wyniki finansowe",
      "ArrivalAndDeparture": "Przyjazd i odbiór",
      "FeedConsumption": "Spożycie paszy",
      "WellBeing": "Dobrostan",
      "RevenueAndCost": "Przychody i koszty"
    },
    "description": "Wgląd w status Twojej fermy w czasie rzeczywistym!",
    "locations": "Lokalizacje",
    "location": "Lokalizacja",
    "cycles": "Cykle produkcyjne",
    "barns": "Kurniki",
    "detail-level": "Poziom szczegółowy",
    "display-type": "Wyświetlanie",
    "kpis-name": "Wskaźniki",
    "table": "Tabela",
    "chart": "Wykres",
    "kpi-selection": "Wskaźniki wybór",
    "aggregation": {
      "Sum": "Łącznie",
      "Average": "Średni",
      "Min": "Min",
      "Max": "Max"
    },
    "custom-footers": {
      "end-total": "Suma końcowa",
      "same-period": "<Tenant> w tym samym okresie (stada:",
      "last-weeks": "<Tenant> ostatnie 10 tygodni (stada:",
      "customer-average-selected-period": "Średnia klienta w wybranym okresie (stada:"
    },
    "no-data": {
      "title": "Brak dostępnych danych",
      "description": "Dane zostaną wyświetlone gdy dostępne będą cykle produkcyjne."
    },
    "no-benchmark": "Niewystarczające dane do ustalenia (potrzebne jest co najmniej 15 stad).",
    "benchmark-title": "<Tenant>",
    "benchmark-selected-period": "w tym samym okresie",
    "benchmark-last-weeks": "ostatnie 10 tygodni",
    "norm": "norma",
    "benchmark-settings": "Ustawienia benchmarku",
    "settings": {
      "header": "Filtry",
      "title": "Ustawienia benchmarku",
      "subtitle": "Tutaj możesz ustawić punkt odniesienia, z którym chcesz porównać swoje pary jeśli nie jesteś w trybie „szczegółowym”",
      "selected-period-label": "<Tenant> wyświetl test porównawczy dla wybranego okresu",
      "last-weeks-label": "<Tenant> wyświetlanie porównawcze ostatnich 10 tygodni",
      "customer-average-selected-period-label": "Wyświetl średnią klienta dla wybranego okresu",
      "none": "Nic",
      "select-multiple-benchmark-label": "Możesz wybrać wiele testów porównawczych",
      "select-one-benchmark-label": "Możesz wybrać tylko jeden test porównawczy",
      "non-detailed-view-label": "Widoki nieszczegółowe",
      "detailed-view-label": "Widoki szczegółowe"
    },
    "reset-filters": "przywrócić filtry",
    "to": "aż do",
    "maxPrintWarning": {
      "title": "Warning",
      "message": "You have selected more than the max number of KPI's you're able to print. Only the first number of KPI's able to print will be shown when printing. Current possible number of KPI's when printing:"
    },
    "kpis": {
      "DayOldChicks": "Ilość piskląt",
      "DayOldChicksPrice": "Wartość piskląt",
      "TotalDeparture": "Łącznie sprzedano",
      "DepartureWeight": "Waga sprzedanych ptaków",
      "SlaughterWeight": "Waga ubojowa",
      "Revenue": "Dochód",
      "FeedBalance": "Spożycie paszy",
      "FeedBalancePrice": "Wartość skarmionej paszy ",
      "LossPercentage": "Upadki procentowe",
      "ReplacementPercentage": "Ilość własnych surowców",
      "FeedConversion": "FCR",
      "FeedConversion1500": "FC1500",
      "AverageWeightInGram": "Średnia waga",
      "WeightedAverageAgeInDays": "Średnia długość cyklu",
      "WeightedAverageGrowthPerDay": "Przyrosty",
      "ProductionNumber": "EWW",
      "DayOldChicksPerSquareMeter": "Ilość piskląt na m²",
      "FeedUsageInKgPerSquareMeter": "Zużycie paszy w kg/m²",
      "FeedConsumptionPricePer100Kg": "Średnia cena paszy",
      "PaidAmountPerKg": "Dochód na kg",
      "NettoRevenue": "Dochód netto",
      "NettoRevenuePerChick": "Dochód netto na ptaka",
      "NettoRevenuePerSquareMeterPerDay": "Dochód netto na m² na dzień",
      "RejectionRate": "Skala odrzucenia",
      "PricePerDayOldChick": "Cena za pisklę",
      "FeedBalanceMixProduct": "Spożycie paszy pełnoporcjowej",
      "FeedBalanceRawProduct": "Spożycie surowców",
      "DeliveredKgPerSquareMeter": "Dostarczone kg na m²",
      "NettoRevenuePerSquareMeter": "Dochód netto na m²",
      "FeedConsumptionPerDeliveredKg": "Koszty paszy na dostarczony kg",
      "DayOldChicksWeight": "Waga piskląt",
      "WeightedHeelDermatitis": "Średnia z zapaleń skóry pięt",
      "WeightedFootpadLesionNonePercentage": "Średnia z odparzeń stópek 0",
      "WeightedFootpadLesionModeratePercentage": "Średnia z odparzeń stópek 1",
      "WeightedFootpadLesionSeverePercentage": "Średnia z odparzeń stópek 2",
      "TotalLoss": "Upadki",
      "WeightedFootpadLesionScore": "Średni wynik - odparzenia stópek",
      "FeedBalanceRawPrice": "Wartość wykorzystanych surowców",
      "FeedBalanceMixPrice": "Wartość skarmionej paszy",
      "PartialDeparture": "Częściowa sprzedaż",
      "FullDeparture": "Całkowita sprzedaż",
      "NettoProfitInclOtherCosts": "Zysk netto z innymi kosztami",
      "DayOldChicksPriceExclDiscounts": "Cena przyjazdu piskląt ekskluzywne rabaty",
      "RevenueExclDiscounts": "Ekskluzywne rabaty przychodowe",
      "FeedBalancePriceExclDiscounts": "Cena za spożycie paszy ekskluzywne rabaty"
    },
    "data-view-types": {
      "PerLocation": "Na lokalizację",
      "PerCycle": "Na cykl produkcyjny",
      "PerCycleBarn": "Na cykl na kurnik",
      "PerLocationBarn": "na kurnik"
    },
    "customer-average-selected-period": "Średnia klienta w wybranym okresie",
    "show-more": "pokaż więcej",
    "show-less": "pokaż mniej"
  },
  "within-cycle-performance": {
    "advice_and_reference-value-sheet": "Porady żywieniowe i karta standardowa",
    "kpi": "KPI",
    "kpis": {
      "IndoorTemperature": "Temperatura wewnętrzna",
      "IndoorHumidity": "Wilgotność wewnętrzna",
      "MortalityPercentage": "Smiertelnosc %",
      "FeedIntakePerChick": "Pobranie paszy (na pisklę)",
      "WaterIntakePerChick": "Pobór wody (na pisklę)",
      "WeightGainPerChick": "Przyrost masy ciała (na pisklę)",
      "WaterToFeedRatio": "Stosunek wody do paszy",
      "FeedConversionRate": "Współczynnik konwersji paszy",
      "LitterQuality": "Jakość ściółki",
      "LitterQualityCaked": "Ciastowata",
      "LitterQualityLoose": "Sucha",
      "LitterQualityWet": "Mokra",
      "BodyWeight": "Masy ciała",
      "GrowthPrediction": "Przewidywanie wzrostu",
      "IndoorOutdoorTemperature": "Temperatura wewnętrzna / zewnętrzna",
      "IndoorOutdoorHumidity": "Wilgotność wewnętrzna / zewnętrzna",
      "OutdoorTemperature": "Temperatura zewnętrzna",
      "OutdoorHumidity": "Wilgotność zewnętrzna"
    },
    "no-data": "Brak dostępnych danych."
  },
  "area": "Powierzchnia kurnika",
  "arrival-date": "Data dostawy",
  "avined": "Avined",
  "balance": {
    "add-manual-delivery": "Dodaj dostawę",
    "balance-row": "Wiersz bilansu",
    "barn-distribution": {
      "available-in-this-cycle": "Dostępne w tym cyklu",
      "change-flock-allocation": "Zmiana podziału dostawy",
      "currently": "Obecnie:",
      "delivery-line-info": "Informacja o dostawie",
      "flock-allocation": "Przydział stada",
      "kg-per-chick": "kg/dostawa piskląt",
      "of-which-remaining": "Z czego pozostałe",
      "total-should-be": "Suma wszystkich ilości powinna wynosić",
      "totally-delivered": "Dostarczone ogółem",
      "usage-in-kg": "Zużycie (kg)",
      "usage-in-other-cycles": "Zastosowanie w innych cyklach",
      "usage-in-this-cycle": "Wykorzystanie w tym cyklu",
      "total": "Całkowity",
      "totalRaw": "Całkowita pasza surowa",
      "totalCompound": "Mieszanka paszowa ogółem"
    },
    "consumption": "Zużyto (kg)",
    "delivery-date": "Data dostawy",
    "empty-day-old-chick-description": "Najpierw wprowadź dostawę. Następnie możesz ją tutaj rozdzielić.",
    "empty-day-old-chick-title": "Brak informacji o wstawieniach",
    "empty-description": "Kliknij 'Przelicz', aby wyświetlić saldo.",
    "empty-title": "Nie znaleziono wierszy bilansu",
    "manual-add": "ręcznie",
    "multiple-deliveries": "Wiele dostaw",
    "price": "Cena",
    "product": "Produkt",
    "quantity": "Ilość (kg)",
    "recalculate": "Przelicz",
    "recalculate-warning": {
      "text": "Wszystkie dostawy pasz dla bieżącego cyklu zostaną ponownie załadowane. Wszelkie nowe dostawy zostaną dodane. Wszystkie pozostałe ilości zostaną ustawione na zero.",
      "title": "Czy na pewno chcesz przeliczyć?"
    },
    "remainder": "Pozostało (kg)",
    "remainder-greater-than-quantity": "Reszta nie może być większa niż ilość.",
    "remainder-less-than-zero": "Wartość w polu Pozostało nie może być mniejsza niż 0.",
    "remainder-less-than-quantity": "Wartość w polu Pozostało nie może być mniejsza niż wartość w polu Ilość.",
    "remainder-greater-than-zero": "Wartość w polu Pozostało nie może być większa niż 0.",
    "remainder-other-than-zero": "Reszta nie może być inna niż 0.",
    "remainder-NaN": "Reszta nie jest prawidłową liczbą.",
    "pending-changes-warning": {
      "title": "Niezapisane zmiany",
      "message": "Masz niezapisane zmiany w saldzie.",
      "confirmText": "Kontynuuj bez zapisywania",
      "cancelText": "Anuluj"
    },
    "save-confirm": {
      "title": "Zapisz ",
      "text": "Bilans nie został jeszcze zakończony. Możesz nadać mu status „zakończony”. Jeśli bilans nie jest jeszcze kompletny, wybierz opcję zapisz. W ten sposób możesz zachować bilans ze statusem „tymczasowy”.",
      "alert": "Sfinalizowanie bilansu jest ważne, ponieważ tylko wtedy runda zostanie uznana w raportach za zakończoną."
    },
    "edit-confirm": {
      "title": "Edytuj saldo",
      "text": "Gdy wybierzesz opcję zmień bilans, jego status zmieni się z „zakończony” na „tymczasowy”. Wtedy możesz dokonywać zmian i ponownie sfinalizować bilans.",
      "alert": "Ponowne sfinalizowanie salda po zmianach jest ważne, ponieważ runda ze wstępnym saldem nie zostanie oznaczona w raportach jako zakończona."
    },
    "not-finalized": {
      "title": "Bilans nie został jeszcze zakończony",
      "message": "Bilans nie został jeszcze zakończony. Możesz to zrobić klikając w zapis i sfinalizuj."
    },
    "save-and-finalize": "Zapisz i zakończ",
    "save": "Zapisz",
    "edit": "Edytuj",
    "edit-balance": "Edytuj saldo",
    "delete-confirm": {
      "text": "Czy na pewno chcesz usunąć dostawę z cyklu?",
      "title": "Ostrzeżenie"
    },
    "has-empty-barns": {
      "title": "Znaleziono wadliwe wiersze salda",
      "message": "Równoważne rzędy zostały znalezione tam, gdzie nie było założonej obory. Ten problem zostanie rozwiązany poprzez ponowne obliczenie salda."
    },
    "barn-name": "Kurnik",
    "invoice-date": "Data faktury",
    "invoice-number": "Numer faktury",
    "delivery-number": "Dostawa ID"
  },
  "balance-item": {
    "add-product": "Wpisz",
    "error-product-selected": "Wybierz produkt",
    "no-products": "Nie znaleziono istniejących produktów.",
    "product": "Produktu"
  },
  "balance-item-delivery": {
    "amount": "Podział paszy na kurniki",
    "current-usage": "Bieżące użycie",
    "error-amount": "Wprowadź ilość",
    "error-no-amount": "Dodaj kwotę za co najmniej jeden kurnik",
    "remaining-of": "pozostały z"
  },
  "balance-item-manual": {
    "amount": "Podział paszy na kurniki",
    "delivery-date": "Data dostawy",
    "error-amount": "Wprowadź ilość",
    "error-delivery-date": "Wprowadź datę dostawy",
    "error-no-amount": "Dodaj kwotę za co najmniej jeden kurnik.",
    "error-price": "Wprowadź wartość netto zamówienia",
    "error-product-title": "Wprowadź opis produktu",
    "error-supplier-name": "Wpisz nazwę dostawcy",
    "error-vat": "Wprowadź procent podatku VAT",
    "price": "Wartość netto (bez VAT)",
    "product-title": "Opis produktu",
    "product-type-multiple": "Pasza pełnoporcjowa",
    "supplier-name": "Nazwa Dostawcy",
    "vat": "VAT"
  },
  "balance-summary": {
    "consumption-per-delivered-chick": "Spożycie paszy/brojlera",
    "final-stock": "ostateczny zapas",
    "initial-stock": "zapas początkowy",
    "title": "Podsumowanie salda",
    "total": "całkowite zużycie paszy",
    "delivery-stock": "dostawa-magazyn",
    "product": "produkt"
  },
  "barn": "Kurnik",
  "barn-item": {
    "area": "Powierzchnia kurnika",
    "error-name-duplicate": "Ta nazwa kurnika jest już w użyciu. Wpisz unikalną nazwę.",
    "error-name-required": "Wpisz nazwę kurnika",
    "error-surface-area": "Wprowadź powierzchnię kurnika",
    "name": "Numer kurnika",
    "animal-group-barn-id": "Animal Group Kurnik",
    "not-mapped": "(Nie zmapowane)"
  },
  "birth-date": "Data wylęgu",
  "breed": "Rasa",
  "cadaver": "Utylizacja",
  "catching": "Załadunek do ubojni",
  "certification": "IKB",
  "chick-price": "Cena netto za pisklę, bez VAT",
  "chickens": "Kurczaki",
  "chicks-parents-age-in-weeks": "Wiek rodziców",
  "chicks-weight-in-grams": "Waga piskląt",
  "close-round": "Zamknij cykl",
  "concept": "Typ hodowli",
  "costs": "Koszty",
  "costs-specification": "Zestawienie kosztów",
  "couple": "Stado",
  "couple-number": "Nr",
  "couples": "Stada",
  "customer-id": "Identyfikator klienta",
  "cycle": "Cykl",
  "cycle-navigation": {
    "balance": "Dostawy paszy",
    "closure": "Zamknięcie cyklu",
    "day-old-chick": "Dostawa piskląt",
    "departure": "Sprzedaż do ubojni",
    "general": "Informacje ogólne"
  },
  "cycle-number": "Nr",
  "enter-amounts": "Wprowadź kwoty",
  "n/a": "n/a",
  "cycle-overview": {
    "barn": "Kurnik",
    "consumption-empty": {
      "description": "Dodaj dostawy paszy, aby zobaczyć wiersze bilansu.",
      "title": "Nie ma wierszy balansu."
    },
    "daily-performance-empty": {
      "description": "Dodaj podaż, aby udostępnić obserwacje tygodniowe / dzienne.",
      "title": "Wpis niedostępny."
    },
    "cycle": "Cykl",
    "delete-cycle": "Usuń",
    "edit-current-week": "Dodaj obserwacje tygodniowe",
    "weekregistration-overview": "Przegląd obserwacji tygodniowych",
    "detailedOverview": "Szczegółowe",
    "edit": "edytuj",
    "edit-cycle": "Edytuj",
    "option-all-barn": "- wybierz kurniki -",
    "panel": {
      "add-day-old-chick": "dodaj podaż",
      "add-departure": "dodaj sprzedaż",
      "amount": "Ilość",
      "balance-overview": "Przegląd sald",
      "balance-title": "Zużycie paszy",
      "birthdate": "Data wylęgu",
      "consumption": "Zużycie (kg)",
      "consumption-per-chick": "Zużycie/brojlera (g)",
      "date": "Data dostawy",
      "day-old-chick-overview": "Przegląd dostaw",
      "day-old-chick-title": "Dostawa piskląt",
      "day-old-chick-total": "Wszystkie dostawy piskląt",
      "departure-overview": "Przegląd sprzedaży do ubojni",
      "departure-title": "Sprzedaż do ubojni",
      "departure-total": "Sprzedaż całkowita",
      "departuredate": "Data sprzedaży",
      "departureweight": "Waga sprzedaży",
      "price": "Cena",
      "price-ex-vat-per-chick": "Cena za pisklę (bez VAT)",
      "price-ex-vat": "Cena netto (bez VAT)",
      "product-title": "Nazwa produktu",
      "product-type-mixedproduct": "Pasza pełnoporcjowa",
      "product-type-rawproduct": "Surowiec",
      "revenue": "Dochodów",
      "slaughterweight": "Waga ubojowa",
      "type": "Typ wprowadzenia",
      "type-full": "Sprzedaż całkowita",
      "type-manual": "Ręcznie",
      "type-partial": "Ubierka",
      "type-platform": "Platformy",
      "type-start": "Platformy",
      "total-consumption": "Całkowite zużycie paszy",
      "daily-performance-title": "Rejestracje tygodniowe i dzienne",
      "edit-current-week": "Dodaj obserwacje tygodniowe",
      "cycle-title": "Cykl",
      "discount-title": "Rabaty",
      "discount-overview": "Przegląd rabatów"
    },
    "placeholder": "- dokonaj wyboru -",
    "start-new-cycle": "Rozpoczynanie nowego cyklu",
    "weekregistration-download": "Pobierz szablon",
    "weekregistration-upload": "Import",
    "weekregistration-select-file": "Wybierz plik...",
    "weekregistration-upload-csv-title": "Wybierz plik CSV do zaimportowania",
    "upload-csv-message": "Nie należy usuwać kolumn z szablonu, nawet jeśli są puste. Pola można pozostawić puste.",
    "upload-csv-notification": "Wybierz plik CSV do zaimportowania",
    "weekregistration-select-interval-type": "Typ interwału",
    "download-weekly-report": "Raport tygodniowy",
    "cycle-start-in-future-warning-description": "Data rozpoczęcia tego cyklu przypada w przyszłości. Z tego powodu nie ma możliwości rejestrowania obserwacji.",
    "cycle-start-in-future-warning-title": "Cykl jeszcze się nie rozpoczął"
  },
  "wdo-labels": {
    "mortality": "Smiertelnosc (szt)",
    "feedIntake": "Pobir paszy",
    "waterIntake": "Pobor wody",
    "indoorTemperature": "Temperatura wewnetrzna",
    "outdoorTemperature": "Temperatura zewnetrzna",
    "indoorHumidity": "Wilgotnosc wewnetrzna",
    "outdoorHumidity": "Wilgotnosc zewnetrzna",
    "weight": "Waga",
    "litterQuality": "Jakość ściółki",
    "litterQualities": {
      "Loose": "Jakość ściółki - sucha",
      "Caked": "Jakość ściółki - ciastowata",
      "Wet": "Jakość ściółki - mokra"
    },
    "selection": "Selekcja ogolna",
    "selectionSmall": "Selekcja waga",
    "selectionLegProblems": "Selekcja nogi",
    "feedIntakeGramPerBird": "Pobór paszy (gram na ptaka)",
    "feedIntakeKg": "Pobór paszy (kg)",
    "waterIntakeMililiterPerBird": "Pobór wody (mililitr na ptaka)",
    "waterIntakeL": "Pobór wody (L)",
    "kilogramSuffix": "Kg",
    "gramSuffix": "Gram",
    "literSuffix": "L",
    "mililiterSuffix": "Ml",
    "ageInDays": "Wiek w dniach"
  },
  "wdo-settings": {
    "title": "Tygodniowe i dzienne obserwacje - ustawienia",
    "disabled-message": "Nie można zmienić tych ustawień, ponieważ wprowadzono rejestrację tygodniową.",
    "startday-description": "Dzień rozpoczęcia w kontekście daty wstawienia piskląt",
    "startday-label": "Ustawienia dni tygodnia",
    "startday-placeholder": "- wybierz dzień rozpoczęcia -",
    "weekly-daily-description": "Tutaj możesz określić jakie dane chcesz wprowadzać codziennie lub co tydzień.",
    "open-settings": "Otwórz ustawienia",
    "general-option": {
      "label": "Ustawienia ogólne",
      "per-day": "Codziennie dla wszystkich",
      "per-week": "Co tydzień dla wszystkich"
    },
    "setting-option": {
      "off": "Wyłączony",
      "per-day": "Codziennie",
      "per-week": "Co tydzień"
    },
    "delete-confirm": {
      "title": "tytuł",
      "text": "tekst"
    }
  },
  "wdo-registration": {
    "all-settings-are-off-title": "Wszystkie pola zostały wyłączone",
    "all-settings-are-off-message": "Przejdź do ustawień dziennych i tygodniowych obserwacji w Menu głównym dla tego cyklu i wprowadź tam swoje ustawienia.",
    "registration": "Rejestracja dziennych i tygodniowych obserwacji",
    "cycle-date": "Data dostawy",
    "cycle-end-date": "Data zakończenia cyklu",
    "select-week": "Tydzień",
    "select-week-placeholder": "- Wybierz tydzień -",
    "select-barn": "Kurnik",
    "select-barn-placeholder": "- Wybierz kurnik -",
    "validation-errors": {
      "total-must-be-100": "The total of the litter quality combined should be 100%.",
      "date-is-not-valid-title": "Nieprawidłowe daty w przesyłanym pliku",
      "date-is-not-valid-description": "W przesyłanym pliku znajdują się dane, których dzień/tydzień jest większy/mniejszy niż data zakończenia/data rozpoczęcia cyklu. Zapisywane są dane z prawidłową datą."
    },
    "next-day": "Następny dzień"
  },
  "wdo-registration-overview": {
    "title": "Przegląd rejestracji obserwacji",
    "weekly-registrations": "Cotygodniowe rejestracje obserwacji",
    "daily-registrations": "Rejestracje dzienne",
    "columns": {
      "weeknr": "Tydzień",
      "date": "Data"
    },
    "no-observations-found": {
      "title": "No observations found",
      "message": "NW tym cyklu nie wprowadzono żadnych obserwacji tygodniowych ani dziennych."
    }
  },
  "chicks": "pisklęta",
  "cycles": "Cykle produkcyjne",
  "dashboard": "Podsumowanie",
  "date": "Data",
  "date-of-arrival": "Data wstawienia",
  "day-old-chicks": "Piskląt",
  "days": "dni",
  "decontamination": "Dezynfekcja obiektu",
  "delete": "Usuń",
  "delete-item-balance": "Czy chcesz usunąć wiersz salda?",
  "delete-item-barn-item": "Czy chcesz usunąć kurnik?",
  "delete-item-day-old-chick": "Czy chcesz usunąć dane dotyczące tego wstawienia piskląt?",
  "delete-item-departure": "Czy chcesz usunąć dane dotyczące tej sprzedaży ptaków?",
  "delete-item-flock-cycle": "Czy chcesz usunąć ten cykl produkcyjny?",
  "delivery": {
    "deliveries": "Dostawy",
    "delivery": "Dostawa"
  },
  "delivery-item": {
    "amount": "Podział na kurniki",
    "delivery-date": "Data dostawy",
    "error-amount": "Wprowadź ilość",
    "error-delivery-date": "Wprowadź datę dostawy",
    "error-no-amount": "Dodaj kwotę za co najmniej jedną stodołę.",
    "error-price": "Wprowadź wartość netto zamówienia",
    "error-product-title": "Wprowadź opis produktu",
    "error-supplier-name": "Wpisz nazwę dostawcy",
    "error-units-delivered": "Wprowadź dostarczoną ilość produktu",
    "error-units-delivered-not-enough": "Część tej dostawy została już wykorzystana w bilansach cykli. Dlatego potrzebujesz co najmniej:",
    "error-vat": "Wprowadź procent podatku VAT",
    "external-product-id": "Numer produktu",
    "manual-delivery": "Dostawa Ręczna",
    "price": " Wartość netto (bez VAT)",
    "product-title": "Opis produktu",
    "product-type-multiple": "Pasza pełnoporcjowa",
    "supplier-name": "Nazwa Dostawcy",
    "units-delivered": "Ilość dostarczona",
    "vat": "VAT",
    "price-per-100kg": "Cena netto za 100 kg (bez VAT)",
    "error-price-per-100kg": "Wpisz cenę netto za 100 kg",
    "barn": "Kurnik",
    "invoice-date": "Data faktury",
    "invoice-number": "Numer faktury",
    "vat-percentage": "Procent VAT"
  },
  "delivery-overview": {
    "active": "Aktywny",
    "delivery": "Dostawa",
    "delivery-lines": "Pozycje dostawy",
    "display-in-cycle": "Wyświetlanie w cyklu",
    "no-deactivation": {
      "description": "Istnieje cykl, w którym stosowana jest ta dostawa.",
      "title": "Dezaktywacja nie jest możliwa"
    },
    "no-deliveries": {
      "description": "Dostawy są dodawane automatycznie i zostaną wyświetlone tutaj.",
      "title": "Brak dostaw"
    },
    "remaining-of": "pozostały z",
    "remove-delivery-warning": {
      "text": "Spowoduje to usunięcie dostawy z listy. Dostaw wykorzystanych w saldach nie można usunąć.",
      "title": "Czy na pewno chcesz usunąć tę dostawę?"
    },
    "table": {
      "deliveryDate": "Data dostarczenia",
      "deliveryId": "Dostawa ID",
      "product": "Produkt",
      "isActive": "Aktywny",
      "showInFinalSetup": "Pokaż w Konfiguracja końcowa",
      "invoiceDate": "Data faktury",
      "invoiceNumber": "Numer faktury"
    }
  },
  "departure": {
    "barn": "Kurnik",
    "empty-day-old-chicks-description": "Dodaj informację o nowym wstawieniu, zostanie wyświetlona w tym miejscu.",
    "empty-day-old-chicks-title": "Brak informacji o wstawieniach",
    "empty-description": "Dodaj informację o sprzedaży ptaków, zostanie wyświetlona w tym miejscu.",
    "empty-title": "Brak informacji o sprzedaży ptaków"
  },
  "departure-date": "Data sprzedaży",
  "departure-item": {
    "age": "Wiek ptaków",
    "amount-of-chicks": "Ilość",
    "average-weight": "Średnia waga PAK",
    "barn": "Kurnik",
    "chicks": "ptaków",
    "date": "Data",
    "error-amount-of-chicks-max": "Maksymalna ilość piskląt to:",
    "error-amount-of-chicks-min": "Dodaj co najmniej 1 brojlera",
    "error-amount-of-chicks-required": "Wprowadź liczbę ptaków",
    "error-barn": "Wybierz kurnik",
    "error-date": "Wprowadź datę wyjazdu. Musi to nastąpić po najwcześniejszej dacie przyjazdu, ale nie w przyszłości.",
    "error-no-chicks-remaining": "Nie ma już kurcząt do sprzedaży",
    "error-type": "Wprowadź typ sprzedaży",
    "footpad-lesion-score": "Ocena odparzeń stópek",
    "footpad-lesion-none": "Ocena 0",
    "footpad-lesion-moderate": "Ocena 1",
    "footpad-lesion-severe": "Ocena 2",
    "footpad-lesion-validation": "Wartości procentowe w Ocena 0, 1 i 2 muszą dodać do 100%",
    "heel-dermatitis": "Zapalenie skóry pięty",
    "revenue": "Całkowite przychody (bez VAT)",
    "slaughter-results": "Dane z ubojni",
    "slaughter-weight": "Waga końcowa po konfiskatach",
    "rejection-at-slaughterhouse": "Odrzucenie w ubojni",
    "rejection-during-transport": "Odrzucenie podczas transportu",
    "slaughterhouse": "Ubojnia",
    "type": "Rodzaj",
    "type-full": "Sprzedaż całkowita",
    "type-partial": "Ubierka",
    "weight": "Waga żywca",
    "weight-validation": "Całkowita masa ubojowa nie może być wyższa niż masa odlotowa.",
    "diverseCosts": "Zróżnicowane koszty",
    "revenueSubTotal": "Wartość (bez VAT)"
  },
  "departure-title": "Sprzedaż do ubojni",
  "departure-type-full": "Sprzedaż całkowita",
  "departure-type-partial": "Ubierka",
  "download-pdf": "Pobierz PDF",
  "edit": "Edytuj",
  "electricity": "Prąd elektryczny",
  "error-amount-of-chickens": "Wprowadź ilość ptaków",
  "error-amount-of-chicks": "Wprowadź ilość piskląt",
  "error-amount-of-chicks-too-big": "Ilość jednodniowych kurcząt jest zbyt wysoka",
  "error-arrival-date": "Wprowadź datę wstawienia piskląt",
  "error-barn-selected": "Wybierz kurnik",
  "error-breed": "Wybierz rasę",
  "error-chick-birth-date": "Wprowadź datę urodzenia piskląt",
  "error-chick-price": "Wprowadź cenę piskąt (za sztukę)",
  "error-concept": "Wybierz typ hodowli",
  "error-cycle-number": "Wprowadź unikalny numer cyklu",
  "error-hatchery": "Wybierz wylęgarnię",
  "error-start-date": "Wprowadź datę rozpoczęcia cyklu",
  "error-surface-area": "Wprowadż powierzchnię kurnika",
  "error-total-costs": "Wprowadź koszty całkowite",
  "error-total-price": "Wprowadź kwotę",
  "feed": "Pasza",
  "flocks": "Stada",
  "general": "Informacje ogólne",
  "grams": "gramy",
  "hatchery": "Wylegarnia",
  "healthcare": "Profilaktyka zdrowotna",
  "heating": "Ogrzewanie",
  "litter": "Ściółka",
  "management": "Zarządzanie",
  "manure": "Czyszczenie obiektu",
  "no-barns-description": "Dodaj nowy kurnik, a pojawi się tutaj.",
  "no-barns-title": "Brak budynków produkcyjnych",
  "no-cycle-selected-description": "Wybierz cykl, aby zobaczyć o nim informację.",
  "no-cycle-selected-title": "Cykl nie został wybrany",
  "no-cycles-description": "Dodaj cykl produkcyjny, zostanie wyświetlony w tym miejscu.",
  "no-cycles-title": "Brak cykli produkcyjnych",
  "no-day-old-chicks-description": "Dodaj informację o nowym wstawieniu, zostanie wyświetlona w tym miejscu.",
  "no-day-old-chicks-title": "Brak informacji o wstawieniach",
  "no-departures-description": "Dodaj informację o sprzedaży ptaków, zostanie wyświetlona w tym miejscu.",
  "no-departures-title": "Brak informacji o sprzedaży bptaków",
  "none": "Żaden",
  "nr": "Nr.",
  "number-of-day-old-chicks": "Ilość piskląt",
  "other": "Pozostałe",
  "print": "Wydrukować",
  "remove-cycle": "Usuń cykl",
  "report-navigation": {
    "barn-report": "Podsumowanie cyklu"
  },
  "report-overview": {
    "barn": "Kurnik",
    "barn-report": "Podsumowanie cyklu",
    "barn-report-loading": "jest generowany...",
    "cycle": "Cykl",
    "reports": "Raporty",
    "cycle-closed": "(Cykl zakończony)"
  },
  "save-as-concept": "Zachowaj typ hodowli",
  "settings": "Ustawienia",
  "settings-navigation": {
    "barns": "Kurnik",
    "observationsetting": "Obserwacje",
    "rvssetting": "Arkusz wartości odniesienia",
    "farmresultsetting": "FarmResult",
    "performance": "Wydajność",
    "finalsetupsetting": "Konfiguracja końcowa",
    "discountsetting": "Zniżki",
    "sustainabilitysetting": "Zrównoważony rozwój"
  },
  "observations-setting": {
    "description": "Czy chcesz śledzić wydajność cyklu co tydzień i codziennie?",
    "switch": "Aktywuj obserwacje tygodniowe/dzienne"
  },
  "column-setting": {
    "title": "Kolumna ustawienia",
    "description": "Kolumny"
  },
  "rvs-setting": {
    "title": "Arkusz wartości odniesienia ustawienia",
    "temperatureInside-option": {
      "label": "Temperatura",
      "Celcius": "Celcius",
      "Fahrenheit": "Fahrenheit",
      "short": {
        "Celcius": "(°C)",
        "Fahrenheit": "(F)"
      }
    },
    "feedIntake-option": {
      "label": "Karmić",
      "Gram": "Gram",
      "Kilogram": "Kilogram",
      "short": {
        "Gram": "(g)",
        "Kilogram": "(kg)"
      }
    },
    "waterIntake-option": {
      "label": "Woda",
      "ML": "Mililitr",
      "DL": "Decylitr",
      "L": "Litr",
      "short": {
        "ML": "(ml)",
        "DL": "(dl)",
        "L": "(l)"
      }
    },
    "weight-option": {
      "label": "Waga",
      "Gram": "Gram",
      "Kilogram": "Kilogram",
      "short": {
        "Gram": "(g)",
        "Kilogram": "(kg)"
      }
    },
    "dayoffset": {
      "title": "Ustawienie dnia rozpoczęcia",
      "label": "dzień rozpoczęcia"
    }
  },
  "specify-costs": "Specyfikacja kosztów",
  "start-date": "Data rozpoczęcia cyklu",
  "title": "PoultryNEXT",
  "title_Agrifirm": "PoultryNEXT",
  "title_Agravis": "Avidata broiler",
  "total-costs": "Koszty całkowite",
  "total-price": "Wartość, bez VAT",
  "unspecified-costs": "Koszty dodatkowe",
  "water": "Woda",
  "water-additives": "Dodatki do wody",
  "weeks": "tygodnie",
  "search": "Szukaj",
  "dateFrom": "Z",
  "dateTo": "Aż do",
  "days-of-week": {
    "Monday": "poniedziałek",
    "Tuesday": "wtorek",
    "Wednesday": "środa",
    "Thursday": "czwartek",
    "Friday": "piątek",
    "Saturday": "sobota",
    "Sunday": "niedziela"
  },
  "unitOfMeasure": {
    "g/day": "g/dzień",
    "€/m²/day": "€/m²/dzień",
    "$/m²/day": "$/m²/dzień",
    "£/m²/day": "£/m²/dzień",
    "zł/m²/day": "zł/m²/dzień",
    "Ft/m²/day": "Ft/m²/dzień"
  },
  "feed-advice": {
    "overview": {
      "title": "Widok ogólny porad żywieniowych",
      "empty": {
        "title": "Porady żywieniowe są niedostępne",
        "description": "W tej chwili nie ma dostępnych porad żywieniowych."
      },
      "table-header": {
        "name": "Nazwa",
        "created": "Utworzono",
        "updated": "Zaktualizowano",
        "updatedAdvisorName": "Zaktualizowano przez",
        "isActive": "Aktywny"
      },
      "buttons": {
        "add": "Utwórz poradę żywieniową",
        "edit": "Edytuj",
        "delete": "Usuń"
      }
    },
    "create-from-reference": {
      "title": "Stwórz porady paszowej",
      "scratch-title": "Zaczynać od początku",
      "scratch-option-title": "Rozpocznij porady paszowej",
      "scratch-button": "Zaczynać od początku",
      "scratch-option-subtitle": "To jest puste porady paszowej",
      "reference-schemes-title": "Wybierz Przegląd porady paszowej jako podstawa",
      "reference-schemes-button": "Dodaj",
      "product": "Produkt",
      "products": "Produkty",
      "additive": "Dodatek paszowy",
      "additives": "Dodatki"
    },
    "dialog": {
      "deleteConfirm": "Czy na pewno chcesz usunąć poradę żywieniową?",
      "deleteConfirmWhenInUse": "Ta porada żywieniowa jest połączona z cyklem. Czy na pewno chcesz usunąć tę poradę żywieniową?"
    },
    "create": {
      "print": "Wydrukować",
      "title": "Porady żywieniowe",
      "name": "Nazwa porady żywieniowej",
      "error-name": "Wymagana jest nazwa porady żywieniowej.",
      "description": "Opis",
      "description-placeholder": "Opis porady żywieniowej",
      "product-placeholder": "- Wybierz produkt -",
      "add-product": "Dodaj produkt",
      "table-header": {
        "productName": "Produkt",
        "chickenWeightInGrams": "Waga pisklęcia (g)",
        "ageFrom": "Wiek od (dni)",
        "ageTo": "Wiek do (dni)",
        "totalFeed": "Pobór paszy (g)",
        "coreFeed": "Pasza (g)",
        "wheatFeed": "Pszenica dodana (g)",
        "comment": "Komentarze",
        "age": "Wiek (dni)",
        "coreFeedTons": "Pasza (tony)",
        "wheatFeedTons": "Pszenica (tony)",
        "dosage": "dozowanie (kg/tonę)",
        "applicationMoment": "aplikacja wiekowa"
      },
      "created": "Utworzony",
      "updated": "Zaktualizowano",
      "number-of-day-old-chicks": "Liczba jednodniowych piskląt",
      "validation-error": {
        "title": "Błędy walidacji",
        "feedadvice-name": "Nazwa Feedadvice jest wymagana",
        "age-from": "Wiek od jest wymagany",
        "chicken-weight": "Waga kurczaka jest wymagana",
        "product": "Produkt jest wymagany",
        "total-feed": "Całkowity kanał jest wymagany",
        "age-to": "Wiek do jest wymagany (z wyjątkiem ostatniej linii)",
        "age-min-max": "Wiek od powinien być niższy niż wiek do."
      },
      "products": "podstawowe porady żywieniowe",
      "additives": "wzbogacenie",
      "show-additives": "pokaż dodatki",
      "add-additive": "dodaj dodatek"
    },
    "print": {
      "farmcompany": "Firma",
      "customernr": "Numer klienta",
      "contactperson": "Osoba kontaktowa",
      "location": "Lokalizacja",
      "customerservice": "obsługa klienta",
      "table-header": {
        "productName": "Produkt",
        "chickenWeightInGrams": "Waga pisklęcia",
        "age": "Wiek",
        "totalFeed": "Pobór paszy",
        "coreFeed": "Pasza",
        "wheatFeed": "Pszenica",
        "comment": "Komentarze",
        "gramPerChick": "g/pisklę",
        "orderQuantity": "Ilość zamówienia (tony)",
        "units_gram": "(g)",
        "units_days": "(dni)",
        "dosage": "Dawkowanie",
        "units_kgton": "kg/tonę",
        "applicationMoment": "Moment aplikacji"
      }
    }
  },
  "standard-reference-value-sheet": {
    "overview": {
      "title": "Standardowy Przegląd arkuszy wartości referencyjnych"
    },
    "create": {
      "title": "Standardowy Arkusz wartości odniesienia"
    }
  },
  "reference-value-sheet": {
    "overview": {
      "title": "Przegląd arkuszy wartości referencyjnych",
      "empty": {
        "title": "Brak danych w arkuszu wartości odniesienia",
        "description": "W tej chwili nie ma dostępnych danych arkusza wartości referencyjnych."
      },
      "table-header": {
        "name": "Nazwa",
        "created": "Utworzono",
        "updated": "Zaktualizowano",
        "updatedAdvisorName": "Zaktualizowano przez",
        "isActive": "Aktywny"
      },
      "buttons": {
        "add": "Utwórz poradę żywieniową",
        "edit": "Edytuj",
        "delete": "Usuń",
        "copy-as-new": "Kopiuj jako nowy",
        "copy-to-other-country": "Skopiuj do innego kraju"
      },
      "country": "Kraj"
    },
    "dialog": {
      "deleteConfirm": "Czy na pewno chcesz usunąć ten arkusz wartości odniesienia?",
      "deleteConfirmWhenInUse": "Ten arkusz wartości referencyjnych jest powiązany z cyklem, czy na pewno chcesz usunąć ten arkusz wartości referencyjnych?"
    },
    "create-from-standard": {
      "title": "Utwórz arkusz wartości odniesienia",
      "scratch-title": "Zaczynać od początku",
      "scratch-option-title": "Rozpocznij arkusz wartości referencyjnych",
      "scratch-button": "Zaczynać od początku",
      "scratch-option-subtitle": "To jest pusty arkusz wartości referencyjnych",
      "reference-value-sheet-title": "Wybierz arkusz wartości odniesienia jako podstawę",
      "reference-value-sheet-button": "Dodaj"
    },
    "create": {
      "print": "Wydrukować",
      "title": "Arkusz wartości odniesienia",
      "name": "Nazwa arkusza wartości odniesienia",
      "error-name": "Nazwa arkusza wartości odniesienia jest wymagana",
      "add-one-day-values-row": "Dodaj dzień",
      "number-of-days": "Dni",
      "add-multiple-day-values-rows": "Dodaj dni",
      "description": "Opis",
      "description-placeholder": "Opis arkusza wartości odniesienia",
      "no-day-values-title": "Arkusz wartości odniesienia jest pusty",
      "no-day-values-description": "Aby rozpocząć, dodaj dni do arkusza wartości referencyjnych poniżej.",
      "table-header": {
        "day": "Dzień",
        "temperatureInside": "Temperatura wewnątrz ",
        "relativeHumidity": "Wilgotność względna (%)",
        "feedIntake": "Pobór paszy ",
        "feedIntakePerChickPerDay": "Pobór paszy (g)",
        "feedIntakeTotal": "Całkowity pobór paszy (g)",
        "feedIntakePerChickTotal": "Całkowity pobór paszy (g)",
        "waterIntake": "Woda (ml)",
        "weight": "Waga (g)",
        "mortality": "Śmiertelność (%)",
        "feedConversion": "Konwersja paszy",
        "waterToFeedRatio": "Woda:Pobór paszy"
      },
      "created": "Utworzony",
      "updated": "Zaktualizowano",
      "validation-error": {
        "title": "Błędy walidacji",
        "refvalsheet-name": "Nazwa arkusza wartości referencyjnej jest wymagana."
      }
    },
    "print": {
      "farmcompany": "Firma",
      "customernr": "Numer klienta",
      "contactperson": "Osoba kontaktowa",
      "location": "Lokalizacja"
    },
    "select-country": {
      "title": "Wybierz kraj",
      "description": "Wybierz kraj, do którego chcesz go skopiować",
      "label": "Kraj"
    }
  },
  "reference-scheme": {
    "overview": {
      "title": "Przegląd porady paszowej",
      "empty": {
        "title": "Przegląd porady paszowej jest niedostępny",
        "description": "W tej chwili nie ma żadnych porad paszowych."
      },
      "table-header": {
        "name": "Nazwa",
        "created": "Utworzony",
        "updated": "Zaktualizowano",
        "updatedAdvisorName": "Zaktualizowane przez",
        "isActive": "Aktywny"
      },
      "buttons": {
        "add": "Utwórz poradę paszową",
        "edit": "Edytuj",
        "delete": "Usuń"
      },
      "country": "Kraj"
    },
    "dialog": {
      "deleteConfirm": "Czy chcesz usunąć poradę paszową?"
    },
    "create": {
      "title": "Utwórz poradę paszową",
      "name": "Nazwa porady paszowej",
      "error-name": "Nazwa porady paszowej jest wymagana.",
      "description": "Opis",
      "description-placeholder": "Opis porady paszowej",
      "product-placeholder": "- Wybierz produkt -",
      "add-product": "Dodaj produkt",
      "table-header": {
        "productName": "Produkt",
        "chickenWeightInGrams": "Waga pisklęcia (g)",
        "ageFrom": "Wiek od (dni)",
        "ageTo": "Wiek do (dni)",
        "totalFeed": "Pobór paszy (g)",
        "coreFeed": "Pasza (g)",
        "wheatFeed": "Pszenica dodana (g)",
        "comment": "Komentarze"
      },
      "created": "Utworzony",
      "updated": "Zaktualizowano"
    }
  },
  "product-title": "Produkty",
  "product-save": "Zapisz produkt",
  "product-saved": "Produkt został zapisany!",
  "product-overview": {
    "title": "Przegląd produktów",
    "overview": {
      "productName": "Nazwa",
      "productCode": "Kod produktu",
      "phase": "Fazy",
      "isActive": "Aktywny",
      "productType-Feed": "Pasza pełnoporcjowa",
      "productType-Additive": "Dodatek paszowy",
      "productType": "Rodzaj produktu"
    },
    "no-products": {
      "title": "Nie znaleziono produktów",
      "description": "Klikając Dodaj produkt można utworzyć."
    },
    "delete-confirmation-title": "Usuń produkt",
    "delete-confirmation-message": "Czy na pewno chcesz usunąć ten produkt?",
    "delete-error-message": "Nie mogliśmy usunąć produktu. Upewnij się, że produkt nie jest używany w schemacie referencyjnym.",
    "delete-error-in-use-message": "Nie mogliśmy usunąć produktu, ponieważ jest on używany w jednej lub kilku poradach dotyczących pasz.",
    "country": "Kraj",
    "delete-confirmation-message-when-in-use": "Ten produkt jest używany w jednej lub kilku poradach dotyczących pliku danych. Czy na pewno chcesz usunąć ten produkt?"
  },
  "create-product": {
    "title-create": "Nowy produkt",
    "title-edit": "Edytuj produkt:",
    "product-name": "Nazwa produktu",
    "phases-label": "Fazy",
    "product-code": "Kod produktu",
    "error-product-name": "Podaj nazwę produktu.",
    "error-product-code": "Proszę podać kod produktu.",
    "error-code-name-already-in-use": "Użyj unikalnej kombinacji nazwy i kodu.",
    "product-type": {
      "label": "Rodzaj produktu",
      "Feed": "Pasza pełnoporcjowa",
      "Additive": "Dodatek paszowy"
    },
    "error-product-type": "Typ produktu jest wymagany."
  },
  "countries": {
    "BE": "Belgia",
    "DE": "Niemcy",
    "HU": "Węgry",
    "NL": "Holandia",
    "PL": "Polska",
    "JO": "Jordania",
    "NG": "Nigeria",
    "JM": "Jamajka",
    "TZ": "Tanzania",
    "DA": "Niemcy-Agravis"
  },
  "save": "Zapisz",
  "report-title": "Podsumowanie cyklu produkcyjnego",
  "report-name": "Stada-report-",
  "report-headers": {
    "general": "Informacje ogólne",
    "day-old-chicks": "Pisklęta",
    "total": "Razem",
    "departures": "Sprzedaż do ubojni",
    "balance": "Bilans paszy",
    "key-figures": "Rozliczenie cyklu",
    "technical": "Parametry techniczne",
    "financial": "Dane finansowe"
  },
  "report-columns": {
    "customer": "Klient",
    "location": "Nazwa lokalizacji",
    "barn": "Kurnik",
    "breed": "Rasa",
    "concept": "Koncepcja żywienia",
    "start-date": "Data sprzedaży",
    "date": "Data rozpoczęcia cyklu",
    "age": "Średnia długość cyklu [dni]",
    "amount": "Ilość",
    "price": "Wartość (bez VAT)",
    "discount": "Upust (bez VAT)",
    "delivered": "Sprzedane [kg]",
    "weight": "Waga [g]",
    "paid": "Rozliczone [kg]",
    "rejected": "Konfiskaty [%]",
    "feed-code": "Kod produktu",
    "feed-name": "Nazwa produktu",
    "consumption": "Zużycie paszy [kg]",
    "consumption-per-day-old-chick": "Zużycie paszy na sztukę [g]",
    "day-old-chicks": "Ilość ptaków na m²",
    "drop-out-total": "Upadki (%)",
    "avg-age": "Średnia długość cyklu (dni)",
    "avg-weight": "Średnia waga brojlera (g)",
    "deliveredkg-per-m2": "Obsada sprzedanych ptaków (kg/m²)",
    "growth": "Przyrosty dobowe (g/dzień)",
    "feed-conversion": "Zużycie paszy FCR",
    "feed-conversion-1500": "FC 1500",
    "replacement": "Surowce własne (%)",
    "avg-rejected": "Średnie konfiskaty (%)",
    "production-number": "EWW",
    "price-per-delivered-chick": "Cena za pisklę (gr)",
    "feed-price-per-100": "Cena paszy za 100kg",
    "feed-price-per-delivered-kg": "Cena paszy za dostarczony kg (ct)",
    "yield-per-kg": "Średnia cena z ubojni za kg",
    "feed-profit": "Zysk netto",
    "feed-profit-per-day-old-chick": "Zysk netto w przeliczeniu na brojler (ct)",
    "feed-profit-per-m2-per-day": "Zysk netto na m² na dzień (ct)",
    "cycle-nr": "Numer cyklu",
    "barns": "Stodoły",
    "netto-profit-incl-other-costs": "Zysk netto z innymi kosztami",
    "discountLabel-ledenvoordeel": "Korzyści dla członków",
    "discountLabel-ledenkorting": "Zniżka dla członków",
    "discountLabel-integratiepremie": "Premia integracyjna",
    "discountLabel-nieuwbouwpremie": "Nowa premia budowlana",
    "discountLabel-ncw": "Dystrybucja wartości bieżącej netto",
    "total-incl-discount": "Razem (w tym rabaty)",
    "discountLabel-korting": "Zniżka",
    "discountLabel-overig": "Inne",
    "discountLabel-nabetaling": "Zwrot płatności",
    "discountLabel-correctievoerprijs": "Korekta feedprice",
    "discountLabel-vergoedingvolgensafspraak": "Wynagrodzenie zgodnie z umową",
    "feed-profit-per-m2": "Zysk netto na m²"
  },
  "total": "całkowity",
  "days-short": "dni",
  "parent-stock-identifier": "Numer Stada Rodzicielskiego",
  "import": "Import",
  "csv-import": {
    "delivery-success": "Dostawy zostały pomyślnie zaimportowane.",
    "departure-success": "Wyjazdy zostały pomyślnie zaimportowane.",
    "errors": {
      "amount-exceeds-remaining": "Wiersz ${rowNumber}: Liczba przekracza liczbę pozostałych piskląt dla kurnika '${barn}'. Maksymalna dozwolona liczba to ${maxAmount}.",
      "barn-not-found": "Wiersz ${rowNumber}: Kurnik '${value}' nie został znaleziony w wybranym cyklu.",
      "configured-slaughterhouses-could-not-be-loaded": "Nie można załadować skonfigurowanych ubojni.",
      "cycle-could-not-be-loaded": "Nie można załadować cyklu '${cycleId}'.",
      "cycle-invalid": "Wyjazdy w pliku CSV są nieprawidłowe dla wybranego cyklu.",
      "cycle-not-found": "Cykl '${cycleId}' nie został znaleziony dla bieżącego klienta/lokalizacji.",
      "date-before-first-arrival": "Wiersz ${rowNumber}: Data musi przypadać w dniu pierwszego przyjazdu lub po nim.",
      "date-in-future": "Wiersz ${rowNumber}: Data nie może być w przyszłości.",
      "duplicate-column": "CSV zawiera zduplikowaną kolumnę '${column}'.",
      "file-empty": "Plik CSV jest pusty.",
      "file-required": "Plik CSV jest wymagany.",
      "file-too-large": "Plik CSV jest zbyt duży. Maksymalny dozwolony rozmiar to ${maxSizeKb} KB.",
      "invalid-date": "Wiersz ${rowNumber}: ${field} jest wymagane i musi być prawidłową datą.",
      "invalid-number": "Wiersz ${rowNumber}: ${field} musi być prawidłową liczbą.",
      "missing-required-columns": "W pliku CSV brakuje wymaganych kolumn: ${columns}.",
      "no-data-rows": "CSV musi zawierać co najmniej jeden wiersz danych.",
      "required-field": "Wiersz ${rowNumber}: ${field} jest wymagane.",
      "required-positive-whole-number": "Wiersz ${rowNumber}: ${field} jest wymagane i musi być dodatnią liczbą całkowitą.",
      "required-valid-number": "Wiersz ${rowNumber}: ${field} jest wymagane i musi być prawidłową liczbą.",
      "skip-import-invalid": "Wiersz ${rowNumber}: Pomiń import musi być puste albo mieć jedną z wartości: yes, no, true, false, 1, 0, x.",
      "slaughterhouse-not-found": "Wiersz ${rowNumber}: Ubojnia '${value}' nie została znaleziona.",
      "too-many-rows": "CSV zawiera zbyt wiele wierszy. Maksymalna dozwolona liczba wierszy to ${maxRows}.",
      "total-slaughterweight-higher-than-departure-weight": "Wiersz ${rowNumber}: Całkowita masa ubojowa nie może być większa niż masa wyjazdowa.",
      "type-invalid": "Wiersz ${rowNumber}: Typ jest wymagany i musi być Pełny albo Częściowy.",
      "unterminated-quote": "CSV zawiera wartość z otwierającym cudzysłowem bez cudzysłowu zamykającego.",
      "unknown": "Import CSV nie powiódł się.",
      "unsupported-file-type": "Obsługiwane są tylko pliki CSV."
    },
    "download-template": "Pobierz szablon",
    "invalid-file": "Wybierz prawidłowy plik CSV.",
    "upload": "Prześlij CSV"
  },
  "slaughter-report": "Raport z uboju",
  "link-slaughter-results-title": "Połącz wyniki uboju",
  "link-slaughter-results-description": "Wybierz raport z obory na ubój. Dla każdego raportu z uboju zostanie utworzony jeden wiersz wyjścia.",
  "slaughter-date": "Data uboju",
  "number-of-chickens": "Liczba kurczaków",
  "departure-weight-kg": "Waga wyjazdu (kg)",
  "show-financial-data": "Pokaż dane finansowe",
  "financial-results": "Wyniki finansowe",
  "link-to-barn": "Link do stodoły",
  "imported-slaughter-report-label": "Importowany raport z uboju",
  "slaughter-weight-kg": "Waga uboju (kg)",
  "veterinary": "Weterynaryjny",
  "employment": "Praca",
  "otherRevenue": "Inne przychody",
  "otherCosts": "Inne koszta",
  "discount-title": "Rabaty",
  "discount-label": "Etykieta rabatowa",
  "discount-applicabilityType": "Dotyczy",
  "discount-amount": "Kwota bez faktura VAT",
  "discount-item": {
    "applicabilityType-arrivalcost": "Koszty przyjazdu",
    "applicabilityType-feedcost": "Koszty paszy",
    "applicabilityType-departurerevenue": "Indulási bevétel",
    "add-discount": "Dodaj rabat",
    "labelType-ledenvoordeel": "Korzyści dla członków",
    "labelType-ledenkorting": "Zniżka dla członków",
    "labelType-integratiepremie": "Premia integracyjna",
    "labelType-nieuwbouwpremie": "Nowa premia budowlana",
    "labelType-ncw": "Dystrybucja wartości bieżącej netto",
    "labelType-korting": "Zniżka",
    "labelType-overig": "Inne",
    "labelType-nabetaling": "Zwrot płatności",
    "labelType-correctievoerprijs": "Korekta feedprice",
    "labelType-vergoedingvolgensafspraak": "Wynagrodzenie zgodnie z umową"
  },
  "discount": {
    "no-discounts-title": "Nie ma jeszcze zniżek.",
    "no-discounts-description": "Dodaj rabat, a pojawi się on tutaj."
  },
  "delete-item-discount": "Czy chcesz usunąć rabat?",
  "farm-result": {
    "table-header": {
      "sensorActuator": "Czujnik/Siłownik Id",
      "barn": "Stodoła",
      "sensorActuatorName": "Czujnika/Siłownika Nazwa ",
      "farmResultLocationId": "Lokalizacji Id"
    },
    "select-barn-placeholder": "- wybierz stodołę -"
  },
  "discountLabel-korting": "Zniżka",
  "discountLabel-overig": "Inne",
  "discountLabel-nabetaling": "Zwrot płatności",
  "discountLabel-correctievoerprijs": "Korekta feedprice",
  "discountLabel-vergoedingvolgensafspraak": "Wynagrodzenie zgodnie z umową",
  "delete-item-day-old-chick-used-in-balance": "Ta dostawa jest obecnie używana na wadze. Jeśli zdecydujesz się usunąć tę dostawę, saldo musi zostać ponownie obliczone. Czy chcesz usunąć dostawę?",
  "edit-day-old-chick_barn-used-in-balance": "Zmieniasz stodołę, która jest używana na wadze. Jeśli zapiszesz tę zmianę, saldo musi zostać ponownie obliczone. Czy chcesz kontynuować?",
  "cycle-description": "Opis",
  "confirm": "Zatwierdź",
  "interval-type-Day": "Dzień",
  "interval-type-Week": "Tydzień",
  "unitOfMeasure-setting": {
    "title": "Jednostka miary",
    "warning": "Zmiana ustawień jednostki miary może skutkować niewielkimi różnicami wartości spowodowanymi zaokrąglaniem matematycznym.",
    "waterIntakeUnit": "Jednostka poboru wody",
    "CumulativeLiter": "Skumulowany litr",
    "MililiterPerBird": "Mililitr na ptaka",
    "feedIntakeUnit": "Jednostka pobierająca paszę",
    "CumulativeKilogram": "Kilogram skumulowany",
    "GramPerBird": "Gram na ptaka"
  },
  "error-amount-of-chicks-minimum": "Minimalna liczba piskląt to:",
  "animal-group": {
    "animalGroupTitle": "Animal Group",
    "switchDay": "Dzień zmiany",
    "addSwitchDay": "Dodaj dzień zmiany",
    "phaseFrom": "Faza od",
    "phaseTo": "Faza do",
    "date": "Data",
    "medication": "Lek",
    "treatmentDateStart": "Początek leczenia",
    "treatmentDateEnd": "Koniec leczenia",
    "addMedication": "Dodaj lek",
    "diagnose": "Rozpoznać chorobę",
    "quantity": "Ilość",
    "unit": "Jednostka",
    "quantityUnitDescriptions": {
      "kilogram": "Kilogramy",
      "gramsPerLitre": "Gramy na litr",
      "percentage": "Procent",
      "gram": "Gramy",
      "noUnit": "Brak jednostki",
      "gramsPerKilogram": "Gramy na kilogram",
      "milligram": "Miligramy",
      "milligramsPerKilogram": "Miligramy na kilogram"
    },
    "vaccination": "Szczepionka",
    "addVaccination": "Dodaj szczepienie",
    "vaccine": "Szczepionka",
    "poultryDisease": "Choroba drobiu",
    "vaccinationMethod": "Metoda szczepienia",
    "validationDialogTitle": "Wymagana informacja",
    "validationDialogMessage": "Proszę wpisać wymagane informacje w tabelach",
    "veterinarianTitle": "Lekarz weterynarii"
  },
  "final-setup-setting": {
    "switch": "Konfiguracja końcowa",
    "chick-delivery-switch": "Dostawy piskląt",
    "feed-delivery-switch": "Dostawy pasz",
    "departure-switch": "Sprzedaż",
    "discount-switch": "Rabaty",
    "title": "Konfiguracja końcowa",
    "default-settings-title": "Ustawienia domyślne",
    "masterdata": {
      "title": "Dane główne",
      "notes": "Notatki",
      "payer": "Płatnik",
      "payer-email": "E-mail płatnika",
      "representative-agrifirm": "Przedstawiciel <Tenant>",
      "separate-stable": "Oddzielna stajnia",
      "integration-premium": "Premia integracyjna",
      "discount-value": "wartość rabatu",
      "agrifirm-member": "Członek <Tenant>"
    }
  },
  "invoice-date": "Data faktury",
  "invoice-number": "Numer faktury",
  "vat-percentage": "Procent VAT",
  "vat": "VAT (%)",
  "amount-including-vat": "Wartość Z VAT (€)",
  "final-setup": {
    "chick-deliveries": "Dostawy piskląt",
    "empty-chick-deliveries-title": "Brak dostaw piskląt",
    "empty-chick-deliveries-description": "Brak dostaw piskląt",
    "day-old-chick": "Pisklęta jednodniowe",
    "feed-deliveries": "Dostawy pasz",
    "empty-feed-deliveries-title": "Brak dostaw paszy",
    "empty-feed-deliveries-description": "Brak dostaw paszy",
    "empty-departures-description": "Żadnych odlotów",
    "departures": "Sprzedaż do ubojni",
    "empty-departures-title": "Żadnych odlotów",
    "discounts": "Rabaty",
    "empty-discounts-title": "Brak rabaty",
    "empty-discounts-description": "Brak rabaty",
    "print-footer": "Wszystkie zawarte umowy oraz dostarczane przez nas produkty i/lub usługi podlegają wyłącznie Ogólnym warunkom dostaw Agrifirm NWE BV. Zostaną one przesłane bezpłatnie na pierwsze żądanie i można je również przeglądać i zapisywać za pośrednictwem: https://www .agrifirm.nl/globalassets/agrifirm-group/agrifirm-nl/leveringsvoorwaarden/general-terms--nl.pdf​",
    "print-footer-agravis": "Wszystkie zawarte umowy oraz dostarczane przez nas produkty i/lub usługi podlegają wyłącznie Ogólnym warunkom dostaw Agravis. Zostaną one przesłane bezpłatnie na pierwsze żądanie.",
    "print-description": "Opis",
    "print-message-line-1": "Szanowny Panie, Pani,",
    "print-message-line-2": "Prześlemy Ci zestawienie faktur za poprzednią rundę.",
    "print-end-line-1": "Powyższy przegląd musi odpowiadać Twojej administracji.",
    "print-end-line-2": "Serdeczne pozdrowienia,",
    "print-company-name": "Agrifirm NWE BV",
    "print-company-name-agravis": "Agravis",
    "print-company-email": "Email: kengetallenadministratie@agrifirm.com",
    "print-company-email-agravis": "Email: info@agravis.nl",
    "print-company-phone": "Telefon: 088 - 488 2976",
    "print-company-phone-agravis": "",
    "print-to-receive": "Przyjmując Cię",
    "print-total-feed": "Całkowita pasza, patrz załącznik ze specyfikacją",
    "print-invoice-number": "Faktury nr.",
    "print-amount-excluding-vat": "Kwota bez VAT",
    "print-vat-amount": "Kwota podatku VAT",
    "print-amount-including-vat": "Kwota z VAT",
    "print-product": "Produkt",
    "print-net-weight": "KG netto",
    "include-in-calculations-label": "Uwzględnij w obliczeniach",
    "print-to-pay": "Żebyś zapłacił",
    "print-payment-terms": "Uprzejmie prosimy o wpłatę powyższej kwoty w terminie 14 dni, podając numer klienta, na rachunek bankowy NL.86.RABO.010.10.50.003.",
    "print-subtotal": "Suma częściowa",
    "feed-delivery-end-date": "Ostateczna data zakończenia cyklu konfiguracji",
    "additional-invoices": "Dodatkowe faktury",
    "empty-additional-invoices-title": "Brak dodatkowych faktur",
    "empty-additional-invoices-description": "Brak dodatkowych faktur",
    "additional-invoices-add": "Dodaj fakturę",
    "additional-invoices-delete-confirm-title": "Usuń dodatkową fakturę",
    "additional-invoices-delete-confirm-description": "Czy na pewno chcesz usunąć tę fakturę?",
    "fixed-price": "umowa o stałej cenie",
    "fixed-price-per-100": "Cena za 100 kg",
    "fixed-price-correction": "Korekta ceny zgodnie z ustaleniami",
    "price-agreement": "porozumienie cenowe",
    "per-100-kg": "/ 100 kg bez VAT."
  },
  "amount-excluding-vat": "Wartość, bez VAT (€)",
  "discount-description": "Opis",
  "discount-showInFinalSetup": "Pokaż w Konfiguracja końcowa",
  "label": "Etykieta",
  "link-slaughter-invoices-description": "Wybierz faktury, które chcesz powiązać z cyklem. Dla każdej faktury w końcowej konfiguracji zostanie utworzony jeden wiersz.",
  "link-slaughter-invoices-title": "Połącz faktury za ubój",
  "slaughter-invoice": "Faktura za ubój",
  "vaccination-price": "Cena szczepienia za pisklę",
  "discount-price": "Zniżka na pisklę, wył. faktura VAT",
  "diverse-price": "Zróżnicowany koszt na pisklę",
  "total-price-including-vat": "Kwota m.in. faktura VAT",
  "total-calculated-amount": "Całkowita kwota",
  "total-calculated-amount-including-vat": "Całkowita kwota z VAT",
  "arrival-notification-cycle-overview": "Cena netto za szczepienie i inne elementy za pisklę są uwzględnione w zestawieniu finansowym, gdzie można znaleźć kwotę całkowitą",
  "arrival-notification-final-setup": "Cena netto za szczepienie i inne elementy za pisklę są uwzględnione w zestawieniu finansowym, gdzie można znaleźć kwotę całkowitą",
  "edit-day-old-chick": "Edytuj Dostawa piskląt",
  "edit-departure": "Edytuj Sprzedaż do ubojni",
  "of-delivery": "Dostawa piskląt",
  "delivery-date": "Data dostawy",
  "delivery-number": "Dostawa ID",
  "base-quantity": "Ilość (kg)",
  "discount-setting": {
    "title": "Zniżki",
    "memberDiscountNL": "Zniżka członkowska (€)",
    "memberBenefitNL": "Korzyści członkowskie (%)",
    "memberBenefitAbroad": "Świadczenie członkowskie za granicą (%)",
    "warning-title": "Strzec się!",
    "warning-message": "Wartości te są stosowane dla wszystkich klientów i lokalizacji. Nie zmieniaj ich."
  },
  "sustainability": {
    "calculations": {
      "source": "Źródło",
      "value": "Wartość",
      "unit": "Jednostka",
      "description": "Zobacz wcześniejsze obliczenia lub oblicz inny cykl.",
      "new": "Nowe obliczenie",
      "result": "Zapisany wynik",
      "history": "Wcześniejsze obliczenia",
      "last-updated": "Ostatnia aktualizacja",
      "history-description": "Wybierz obliczenie, aby zobaczyć wynik.",
      "calculation": "Obliczenie",
      "view-result": "Zobacz wynik",
      "empty": "Nie zapisano jeszcze obliczeń dla tego cyklu.",
      "select-cycle": "Wybierz cykl, aby zobaczyć zapisane obliczenia.",
      "loading": "Ładowanie obliczeń…",
      "load-error": "Nie udało się załadować obliczeń. Spróbuj ponownie.",
      "retry": "Spróbuj ponownie",
      "pending": "To obliczenie jest nadal przetwarzane. Odśwież wynik później.",
      "calculating": "Importowanie pasz i obliczanie śladu węglowego…",
      "result-failed": "To obliczenie nie powiodło się. Sprawdź wymagania w panelu obliczeń i spróbuj ponownie. Jeśli problem się powtarza, skontaktuj się z doradcą.",
      "attempt-failed": "Ostatnia próba nie powiodła się. Sprawdź wymagania poniżej i spróbuj ponownie. Zapisane wyniki pozostają dostępne.",
      "status": {
        "complete": "Obliczono",
        "pending": "Przetwarzanie",
        "failed": "Niepowodzenie"
      }
    },
    "readiness": {
      "view-details": "Pokaż dane paszy",
      "requirements-met": "wymagań spełnionych",
      "title": "Wymagania",
      "checking": "Sprawdzanie wymaganych danych…",
      "error": "Nie można sprawdzić wymaganych danych. Spróbuj ponownie.",
      "ready": "Wymagane dane kompletne.",
      "blocked": "Uzupełnij poniższe dane przed obliczeniem.",
      "complete": "Kompletne",
      "action-required": "Wymagane działanie",
      "edit-arrivals": "Edytuj wstawienia",
      "edit-departures": "Edytuj odstawienia",
      "edit-resources": "Edytuj energię za rok",
      "edit-bedding": "Edytuj ściółkę",
      "advisor": "Skontaktuj się z doradcą, aby poprawić te dane. Przekaż powyższe informacje o produkcie i dostawie.",
      "disclaimer": "Sprawdzane są wymagane dane. Sustell nadal może odrzucić obliczenie.",
      "recheck": "Sprawdź ponownie",
      "calculation-failed": "Sustell nie mógł obliczyć tego śladu węglowego. Sprawdź poniższe wymagania i spróbuj ponownie. Jeśli problem się powtarza, skontaktuj się z doradcą.",
      "requirements": {
        "cycle": "Wstawienia, odstawienia i poprawne daty",
        "farm-resources": "Energia za każdy wymagany rok",
        "bedding": "Dane ściółki",
        "feeds": "Wartości odżywcze i emisje paszy"
      },
      "arrival-weight": "Średnia masa przy wstawieniu na ptaka",
      "departure-weight": "Średnia masa przy odstawieniu na ptaka",
      "issues": {
        "feeds-missing": "Zarejestruj zużycie paszy pełnoporcjowej w bilansie paszowym tego cyklu.",
        "arrivals-missing": "Zarejestruj wstawienia piskląt.",
        "departures-missing": "Zarejestruj odstawienia.",
        "cycle-dates-invalid": "Popraw daty cyklu, wstawień i odstawień.",
        "arrival-data-invalid": "Wprowadź dodatnią liczbę ptaków i masę przy wstawieniu w gramach na ptaka.",
        "departure-data-invalid": "Wprowadź dodatnią liczbę ptaków i całkowitą masę przy odstawieniu w kg.",
        "departure-weight-below-arrival": "Średnia masa przy odstawieniu musi być co najmniej równa średniej masie przy wstawieniu. Sprawdź masę przy wstawieniu w gramach na ptaka, całkowitą masę przy odstawieniu w kg i liczbę ptaków.",
        "farm-resources-missing": "Zarejestruj zużycie energii za rok",
        "cycle-dates-required": "Zarejestruj poprawne wstawienia i odstawienia, aby sprawdzić wymagane lata.",
        "bedding-type-missing": "Wybierz rodzaj ściółki.",
        "bedding-amount-missing": "Podaj ilość ściółki.",
        "ship-to-missing": "Miejsce dostawy nie jest powiązane z dostawcą paszy.",
        "delivery-missing": "Dane dostawy są niedostępne.",
        "delivery-line-missing": "Dane dostarczonego produktu są niedostępne.",
        "feed-data-invalid": "Wymagane dane paszy są brakujące lub nieprawidłowe.",
        "feed-settings-missing": "Ustawienia importu paszy są niekompletne.",
        "farm-resources-not-calculated": "Zapisz ponownie dane energii, aby przypisać zużycie do tego cyklu."
      },
      "fields": {
        "Consumption": "Zużycie paszy (kg), większe od zera",
        "Co2Total": "Całkowity ślad węglowy",
        "Co2TotalMismatch": "Suma CO₂ nie odpowiada sumie emisji biogenicznych, kopalnych i związanych ze zmianą użytkowania gruntów. Poproś doradcę o poprawienie danych paszy.",
        "Biogenic": "Emisje biogeniczne",
        "FossilExcludingPeatEmissions": "Emisje kopalne bez torfu",
        "FossilPeatEmissions": "Emisje torfu",
        "LandUseChange": "Emisje ze zmiany użytkowania gruntów",
        "DryMatterAmount": "Zawartość suchej masy",
        "RoughProtein": "Zawartość białka",
        "ProductIdentifier": "Numer produktu"
      },
      "edit-feeds": "Edytuj bilans paszowy",
      "edit-cycle": "Edytuj cykl"
    },
    "sustainability": "Zrównoważony rozwój",
    "farm-resources": "Energia na rok",
    "carbon-footprint": "Ślad węglowy",
    "add-farm-resources": "Dodaj zasoby farmy",
    "confirm-delete-farm-resource": "Usunąć zasób farmy?",
    "farm-resource-deleted": "Usunięto zasób farmy",
    "farm-resource-saved": "Zaoszczędzono zasoby gospodarstwa",
    "year": "Rok",
    "farm-settings-saved": "Ustawienia farmy zostały zapisane",
    "farm-settings-enable-co2-calculation": "Włącz obliczenia CO2 dla tej farmy",
    "resource": {
      "electricity": "Energia elektryczna (kWh)",
      "electricity-photovoltaic": "Energia elektryczna Słońce (kWh)",
      "electricity-wind": "Energia elektryczna Wiatr (kWh)",
      "natural-gas": "Gaz ziemny (m³)",
      "diesel": "Diesel (L)",
      "gasoline": "Benzyna (L)",
      "coal": "Węgiel (KG)",
      "propane-lpg": "Propan / LPG (L)",
      "water": "Woda (m³)",
      "cycle-start-date": "Data rozpoczęcia",
      "cycle-end-date": "Data zakończenia",
      "status": "Status",
      "statuses": {
        "complete": "Kompletny",
        "partial": "Częściowy"
      },
      "water-error": "Woda musi być liczbą dodatnią",
      "electricity-error": "Prąd musi być liczbą dodatnią",
      "electricity-photovoltaic-error": "Energia słoneczna musi być liczbą dodatnią",
      "electricity-wind-error": "Energia wiatru musi być liczbą dodatnią",
      "natural-gas-error": "Gaz ziemny musi być liczbą dodatnią",
      "diesel-error": "Diesel musi być liczbą dodatnią",
      "gasoline-error": "Benzyna musi być liczbą dodatnią",
      "propane-lpg-error": "Propan/LPG musi być liczbą dodatnią",
      "coal-error": "Węgiel musi być liczbą dodatnią"
    },
    "farm-resources-title": "Roczne zużycie energii",
    "cycle-resources": "Zużycie energii na cykl",
    "value": "Wartość masy ciała (kg CO2eq/kg masy ciała)",
    "notification-title": "Ważne informacje dotyczące obliczeń CO2",
    "notification-description": "Obliczanie śladu węglowego odbywa się za pomocą oprogramowania LCA Sustell. Podstawą są obliczenia emisji CO2 dla paszy zgodnie z aktualną instrukcją Nevedi. Aby przeprowadzić prawidłowe obliczenia, wszystkie dane muszą być wprowadzone kompletnie, takie jak <b>wyniki techniczne stada, w tym produkcja i wywóz/ubój oraz zużycie energii.</b>\nPrezentowane wartości mogą ulec zmianie w związku z rozwojem nauk o klimacie i wynikającymi z tego zmianami w systemach obliczeniowych, a także zmianami w przepisach prawnych oraz obowiązujących normach. Mimo że przedstawione tutaj informacje zostały przygotowane z należytą starannością, nie można z nich wywodzić żadnych praw.",
    "action-text-close": "Ukrywać",
    "action-text-open": "Pokazywać",
    "farm-resources-not-complete": "Zasoby cyklu nie są kompletne.",
    "bedding-type-required": "Typ podłoża jest wymagany dla danego cyklu.",
    "bedding-amount-required": "Do przeprowadzenia cyklu wymagana jest odpowiednia ilość pościeli.",
    "start-calculation": "Rozpoczęcie obliczania CO2",
    "refresh-carbon-footprint": "Odświeżenie śladu CO2",
    "carbon-footprint-title-error": "Błąd obliczania śladu węglowego",
    "carbon-footprint-title": "Obliczanie śladu węglowego",
    "carbon-footprint-text": "Rozpocznie się obliczanie śladu węglowego. Prosimy o cierpliwość podczas trwania procesu (około 1 minuty).",
    "carbon-footprint-refresh-error-title": "Nie udało się odświeżyć śladu węglowego",
    "carbon-footprint-refresh-error-text": "Nie udało się odświeżyć śladu węglowego. Spróbuj ponownie za chwilę."
  },
  "bedding-type": "Rodzaj pościeli",
  "bedding-types": {
    "NoBedding": "Bez pościeli",
    "BarleyStraw": "Słoma jęczmienna",
    "MaizeStover": "Słoma kukurydziana",
    "OatStraw": "Słoma owsiana",
    "SawDust": "Trociny",
    "SunflowerHusk": "Łupina słonecznika",
    "WheatStraw": "Słoma pszeniczna",
    "Woodshavings": "Wióry drzewne"
  },
  "bedding-amount": "Ilość pościeli",
  "bedding-amount-error": "Ilość pościeli musi być liczbą dodatnią",
  "transport-distance": "Transport z wylęgarni",
  "transport-distance-error": "Transport z ośrodka hodowlanego musi być liczbą z przedziału od 0 do 1000",
  "time-in-free-range": "Czas na wolnym wybiegu",
  "time-in-free-range-error": "Czas spędzony na wolności musi być liczbą z przedziału od 0 do 100",
  "general-settings-error": "Wystąpił błąd podczas pobierania ustawień dla PoultryNEXT.",
  "tenants": {
    "Agrifirm": "agrifirm",
    "Agravis": "agravis"
  }
}
